/**
 * Error HTTP normalizado que producen los interceptores del AxiosClient.
 * Toda la app consume errores de red a través de este value object.
 */
export class NormalizedHttpErrorValueObject {
  constructor(
    public readonly status: number | undefined,
    public readonly message: string,
    public readonly url?: string,
    public readonly method?: string,
    public readonly code?: string
  ) {}
}
